module.exports = __webpack_public_path__ + "static/media/18ECA27.77e4c249.jpg";